import { jsx as _jsx } from "react/jsx-runtime";
import NativeUiMap from "../specs/OneNativeUiMapNativeComponent";
import { resolveNativeMapModel } from "./mapValidation";
function Map(param) {
  var { cameraPosition, markers, polylines, polygons, circles, onCameraMove, onMarkerClick, onMapClick, style, testID, accessibilityLabel } = param;
  var model = resolveNativeMapModel({
    cameraPosition,
    markers,
    polylines,
    polygons,
    circles
  });
  return /* @__PURE__ */ _jsx(NativeUiMap, {
    style,
    testID,
    accessibilityLabel,
    latitude: model.latitude,
    longitude: model.longitude,
    zoom: model.zoom,
    markers: model.markers,
    overlays: model.overlays,
    onNativeUiMapCameraMove: function onNativeUiMapCameraMove(param2) {
      var { nativeEvent } = param2;
      return onCameraMove === null || onCameraMove === void 0 ? void 0 : onCameraMove({
        coordinates: {
          latitude: nativeEvent.latitude,
          longitude: nativeEvent.longitude
        },
        zoom: nativeEvent.zoom
      });
    },
    onNativeUiMapMarkerClick: function onNativeUiMapMarkerClick(param2) {
      var { nativeEvent } = param2;
      var marker = (markers !== null && markers !== void 0 ? markers : []).find(function(item) {
        return item.id === nativeEvent.id;
      });
      if (marker) onMarkerClick === null || onMarkerClick === void 0 ? void 0 : onMarkerClick(marker);
    },
    onNativeUiMapClick: function onNativeUiMapClick(param2) {
      var { nativeEvent } = param2;
      return onMapClick === null || onMapClick === void 0 ? void 0 : onMapClick({
        coordinates: {
          latitude: nativeEvent.latitude,
          longitude: nativeEvent.longitude
        }
      });
    }
  });
}
export {
  Map
};
//# sourceMappingURL=Map.android.js.map
